<template>
    <MainHeaderComponent :onlyPersonalAccount="true"/>
    <ChooseRole/>
</template>


<script>
    import MainHeaderComponent from '@/components/laptop/MainHeaderComponent.vue';
    import ChooseRole from '@/components/laptop/Authorization/ChooseRole.vue';

    export default {
        name: "ChooceRoleView",
        components: {
            ChooseRole,
            MainHeaderComponent,
        },
        data() {
            return {

            }
        },
        methods: {
            async start() {
                await this.$store.dispatch("setRoleData", null);
                await this.$store.dispatch("setCompanyIdData", null)
            }
        },
        async created() {
            await this.start()
        }
    }
</script>